import { render } from "./fundreport.vue?vue&type=template&id=c57a4138&scoped=true"
import script from "./fundreport.vue?vue&type=script&lang=js"
export * from "./fundreport.vue?vue&type=script&lang=js"

import "./fundreport.vue?vue&type=style&index=0&id=c57a4138&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57a4138"]])

export default __exports__